export const nbItemsDisplayed = 4;
export const nbItemsDisplayedNoActiveItem = 5;
